import { Tabs } from 'antd'

import { useAttributeProcessingContext } from '../../AttributeProcessingContext'
import cn from './RightPanel.module.scss'
import AttachmentsTab from './tabs/AttachmentsTab/AttachmentsTab'
import CategoriesTab from './tabs/CategoriesTab/CategoriesTab'
import CreationTab from './tabs/CreationTab/CreationTab'
import ProcessingTab from './tabs/ProcessingTab/ProcessingTab'

function RightPanel() {
  const { activeTab, handleTabChange } = useAttributeProcessingContext()

  return (
    <div className={cn.rightPanel}>
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        className={cn.tabs}
        items={[
          { key: 'ADDITIONAL', label: 'Доп. реквизиты' },
          { key: 'MAIN', label: 'Основные рекв.' },
          { key: 'CREATE', label: 'Создание' },
          { key: 'CATEGORIES', label: 'Категории' },
          { key: 'ATTACHMENTS', label: 'Вложения' },
        ]}
      />

      <div className={cn.tabContent}>
        {(activeTab === 'ADDITIONAL' || activeTab === 'MAIN') && (
          <ProcessingTab />
        )}
        {activeTab === 'CREATE' && (
          <div className={cn.tabContentScroll}>
            <CreationTab />
          </div>
        )}
        {activeTab === 'CATEGORIES' && <CategoriesTab />}
        {activeTab === 'ATTACHMENTS' && (
          <div className={cn.tabContentScroll}>
            <AttachmentsTab />
          </div>
        )}
      </div>
    </div>
  )
}

export default RightPanel
